import { Tab } from "@headlessui/react";
import { twMerge } from "tailwind-merge";

export const NavigationTab = ({
  children,
  className,
  variant = "underline",
  showRedDot = false,
}: {
  children: string;
  className?: string;
  variant?: "underline" | "button";
  showRedDot?: boolean;
}) => {
  return (
    <Tab
      className={twMerge(
        "flex h-[45px] min-w-[120px] flex-1 cursor-pointer items-center justify-center whitespace-nowrap transition-colors",
        variant === "underline" &&
          "border-b-solid border-b-[3px] border-b-transparent bg-white font-semibold hover:bg-gray-50 data-selected:border-b-black data-selected:font-bold dark:bg-zinc-900 dark:text-zinc-300 dark:hover:bg-zinc-800 dark:data-selected:border-b-white dark:data-selected:text-white",
        variant === "button" &&
          "bg-white text-sm font-semibold text-zinc-500 hover:bg-zinc-50 hover:text-zinc-900 data-selected:bg-zinc-100 data-selected:text-zinc-900 dark:bg-transparent dark:text-zinc-400 dark:hover:bg-zinc-800 dark:hover:text-white dark:data-selected:bg-zinc-800 dark:data-selected:text-white",
        className,
      )}
    >
      <div className="flex items-center gap-1">
        {children}
        {showRedDot && <div className="h-2 w-2 rounded-full bg-red-500"></div>}
      </div>
    </Tab>
  );
};
